import { useMemo } from 'react';
import { CardShipmentItemPayload, CardShipmentStatus } from '@common-fe/common-fe';

interface Props {
  fraudConfirmed?: boolean;
  fraudConfirmedDate?: Date | null;
}

const useGetFraudConfirmedShipmentItem = ({ fraudConfirmed, fraudConfirmedDate }: Props) => {
  const fraudConfirmedShipment = useMemo((): CardShipmentItemPayload | undefined => {
    if (fraudConfirmed && fraudConfirmedDate) {
      return {
        date: fraudConfirmedDate,
        status: CardShipmentStatus.Fraud,
      };
    }
  }, [fraudConfirmedDate, fraudConfirmed]);
  
  return {
    fraudConfirmedShipment,
  };
};

export default useGetFraudConfirmedShipmentItem;
